import React from "react"
import { BASE, RADIO } from "../modules/constants";
const { FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } = require("@mui/material")
const newsTimePeriodForm = props => {
  // console.log('nsmDurationForm props:', props)
  const { radio } = props

  const handleChangeRadio = (event: React.ChangeEvent<HTMLInputElement>) => {
    // Radio button value must be a string so we change this to an int
    props.handleChangeRadio(parseInt(event.target.value))
  }

  return (
    <FormControl >
      <FormLabel id="demo-row-radio-buttons-group-label" style={{ fontSize: 14, fontWeight: "bold", color: "black", marginTop: 10 }} >Time period</FormLabel>
      <RadioGroup
        row
        aria-labelledby="demo-row-radio-buttons-group-label"
        value={radio[BASE.LSE.NEWS].toString()} // numbers cannot be used as radio values, so we must convert to string
        onChange={handleChangeRadio}
        name="row-radio-buttons-group"
      >
        <FormControlLabel
          value={RADIO[BASE.LSE.NEWS].MONTH.toString()} control={<Radio />}
          label="month"
        />
        <FormControlLabel
          value={RADIO[BASE.LSE.NEWS].YEAR.toString()} control={<Radio />}
          label="year"
        />
      </RadioGroup>
    </FormControl>
  )
}

export default newsTimePeriodForm